// extracted by mini-css-extract-plugin
export default {"modal":"KM-z","modalOverlay":"LM-z","outfitHeading":"MM-z"};